import { RefetchAction, RefetchTypes } from "../types/refetch";

export const ArtworkRefetch = (): RefetchAction => ({
  type: RefetchTypes.REFETCH_TOGGLE,
});
